import { httpRequest } from "../../http";

export class CommandDownloadQuarantine {
  async run(key: string): Promise<{ url: string }> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/quarantine/download/?key=${encodeURIComponent(key)}`;
    return httpRequest<{ url: string }>(url, { method: "GET" });
  }
}
